import { render, staticRenderFns } from "./pay_result.vue?vue&type=template&id=0c2f5d00&scoped=true"
import script from "./pay_result.vue?vue&type=script&lang=js"
export * from "./pay_result.vue?vue&type=script&lang=js"
import style0 from "./pay_result.vue?vue&type=style&index=0&id=0c2f5d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f5d00",
  null
  
)

export default component.exports